import React, { useContext, useEffect, useState } from "react";

import { getUserHistory } from "../lib/data";
import authContext from "../../../../contexts/auth/authContext";

const RecentTab = (props) => {
    const auth = useContext(authContext);
    const [options, setOptions] = useState([]);

    useEffect(() => {
        async function init() {
            const data = await getUserHistory(auth.user.email);

            if (!data) {
                return;
            }

            setOptions(data);
        }

        init();
    }, []);

    const htmlOptions = options.map((o, i) => {
        return (
            <li key={`history_${i}`}>
                <button
                    className="button -text"
                    onClick={() => {
                        props.updateSelected(o);
                    }}
                >
                    {o.pathing}
                </button>
            </li>
        );
    });

    return (
        <div className="tab-recent">
            <div className="content">
                <ul className="options-list">{htmlOptions}</ul>
            </div>
        </div>
    );
};

export default RecentTab;
